import { render, staticRenderFns } from "./Activeok.vue?vue&type=template&id=43a189ba&"
import script from "./Activeok.vue?vue&type=script&lang=js&"
export * from "./Activeok.vue?vue&type=script&lang=js&"
import style0 from "./Activeok.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports